import Skeleton from "features/ui/Skeleton";

export const FilterSkeleton = () => (
  <span>
    <Skeleton width={250} height={40} />
  </span>
);
